import { createI18n } from 'vue-i18n';
import zh from './locales/zh';
import en from './locales/en';
import ar from './locales/ar';

// 支持的语言列表
export const supportedLocales = [
  { code: 'zh', name: '简体中文', flag: '🇨🇳' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  // { code: 'ar', name: 'العربية', flag: '🇸🇦' }
];

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('locale') || 'zh', // 默认语言
  fallbackLocale: 'zh', // 回退语言
  messages: {
    zh,
    en,
    ar,
  },
  // 数字和日期格式化
  numberFormats: {
    zh: {
      currency: {
        style: 'currency',
        currency: 'CNY',
      },
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'USD',
      },
    },
    ar: {
      currency: {
        style: 'currency',
        currency: 'SAR',
      },
    },
  },
  // 日期格式化
  datetimeFormats: {
    zh: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
    },
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
    },
    ar: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
    },
  },
});

export default i18n;
